<template>
  <div class="contenedor-barraswaffleadas" :id="contenedor_id">
    <div class="tooltip" :id="tooltip_id">
      El <span class="highlight">{{ tooltip_prcntg_causa }}%</span> murieron por
      <span class="highlight">{{ tooltip_causa }}</span
      >. De ellos, el
      <span class="highlight">{{ tooltip_prcntg_lugar }}%</span> ocurrieron en:
      <span class="highlight">{{ tooltip_lugar }}</span>
    </div>

    <svg
      :id="barraswafleadas_id"
      :width="ancho + margenes.derecha + margenes.izquierda"
      :height="alto_svg"
    >
      <g
        class="eje-x"
        :transform="`translate(${margenes.izquierda},${margenes.arriba})`"
      ></g>
      <g
        class="eje-y"
        :transform="`translate(${margenes.izquierda},${margenes.arriba})`"
      ></g>
      <g
        class="grupo-barras"
        :transform="`translate(${margenes.izquierda},${margenes.arriba})`"
      ></g>
      <g
        class="grupo-afuego"
        :transform="`translate(${margenes.izquierda},${margenes.arriba})`"
      ></g>
      <g
        class="grupo-ablanca"
        :transform="`translate(${margenes.izquierda},${margenes.arriba})`"
      ></g>
      <g
        class="grupo-asfixia"
        :transform="`translate(${margenes.izquierda},${margenes.arriba})`"
      ></g>
      <g
        class="grupo-otras"
        :transform="`translate(${margenes.izquierda},${margenes.arriba})`"
      ></g>
      <g
        class="grupo-se"
        :transform="`translate(${margenes.izquierda},${margenes.arriba})`"
      ></g>
    </svg>
  </div>
</template>

<script setup>
import * as d3 from "d3";
import { ref, toRefs, onMounted, onUnmounted } from "vue";

// eslint-disable-next-line
const props = defineProps({
  datos: {
    type: Array,
    default: Array,
  },
  contenedor_id: {
    type: String,
    default: String,
  },
  barraswafleadas_id: {
    type: String,
    default: String,
  },
  tooltip_id: {
    type: String,
    default: String,
  },
  titulo: {
    type: String,
    default: String,
  },
});
const { datos } = toRefs(props);
const { contenedor_id } = toRefs(props);
const { barraswafleadas_id } = toRefs(props);
const { tooltip_id } = toRefs(props);
const { titulo } = toRefs(props);
const data = ref(datos);
const causas = ref([
  "Sin especificar",
  "Otras",
  "Asfixia",
  "Arma blanca",
  "Arma de fuego",
]);

/* const color_dict = ref({
  calle: "#8C373F",
  vivienda: "#E07D40",
  otro: "#476F8F",
  se_ignora: "#45425A",
}); */

const contenedor_barraswafleadas = ref();
const bars_color = ref("#C6C7C9");

const grupo_barras = ref();
const grupo_afuego = ref();
const grupo_ablanca = ref();
const grupo_asfixia = ref();
const grupo_otras = ref();
const grupo_se = ref();

const svg = ref();
const alto = ref();
const alto_svg = ref(600);
const ancho = ref(0);
const margenes = ref({
  derecha: 10,
  izquierda: 40,
  abajo: 10,
  arriba: 40,
});

const eje_X = ref();
const eje_Y = ref();
const escala_X = ref();
const escala_Y = ref();
const escala_subY = ref();
const texto_x = ref();
const texto_y = ref();
const diferencia = ref();
const ancho_rect = ref();
const borde = ref();

const el_tooltip = ref();
const tooltip_causa = ref();
const tooltip_prcntg_causa = ref();
const tooltip_lugar = ref();
const tooltip_prcntg_lugar = ref();

onMounted(() => {
  contenedor_barraswafleadas.value = document.getElementById(
    `${contenedor_id.value}`
  );
  svg.value = d3.select(`svg#${barraswafleadas_id.value}`);
  eje_X.value = svg.value.select("g.eje-x");
  eje_Y.value = svg.value.select("g.eje-y");
  grupo_barras.value = svg.value.select("g.grupo-barras");
  grupo_afuego.value = svg.value.select("g.grupo-afuego");
  grupo_ablanca.value = svg.value.select("g.grupo-ablanca");
  grupo_asfixia.value = svg.value.select("g.grupo-asfixia");
  grupo_otras.value = svg.value.select("g.grupo-otras");
  grupo_se.value = svg.value.select("g.grupo-se");

  texto_x.value = svg.value.append("text").attr("text-anchor", "middle");
  texto_y.value = svg.value.append("text").attr("text-anchor", "middle");

  el_tooltip.value = d3.select(`div#${tooltip_id.value}`);
  el_tooltip.value.style("visibility", "hidden");

  //console.log(data.value);
  dimensionding();
  dibujanding();
  window.addEventListener("resize", reescalanding);
});
onUnmounted(() => {
  window.removeEventListener("resize", reescalanding);
});

function reescalanding() {
  dimensionding();
  dibujanding();
}
function dimensionding() {
  ancho.value =
    contenedor_barraswafleadas.value.clientWidth -
    margenes.value.derecha -
    margenes.value.izquierda;

  if (ancho.value < 850) {
    borde.value = 1;
  } else {
    borde.value = 3;
  }
  if (ancho.value < 850) {
    diferencia.value = 2;
  } else {
    diferencia.value = 5;
  }
  ancho_rect.value = ancho.value / 50 - diferencia.value;

  alto_svg.value = ancho.value;
  alto.value = alto_svg.value - margenes.value.arriba - margenes.value.abajo;

  escala_X.value = d3.scaleLinear().domain([0, 50]).range([0, ancho.value]);

  escala_Y.value = d3
    .scaleBand()
    .domain(causas.value)
    .range([alto.value, 0])
    .padding(0.03);

  escala_subY.value = d3
    .scaleBand()
    .domain(d3.range(0, 10))
    .range([escala_Y.value.bandwidth(), 0])
    .padding(0.1);

  eje_X.value.call(
    d3
      .axisTop(escala_X.value)
      .ticks(6)
      .tickFormat((d) => d + "%")
  );
  eje_Y.value.call(d3.axisLeft(escala_Y.value));

  eje_Y.value
    .selectAll("text")
    .attr("transform", "translate(-13, -7) rotate(-90) ")
    .attr("text-anchor", "middle");

  texto_x.value
    .attr(
      "x",
      (ancho.value + margenes.value.izquierda + margenes.value.derecha) / 2
    )
    .attr("y", margenes.value.arriba - 25)
    .attr("font-size", "16")
    .attr("font-family", "Avenir, Helvetica, Arial, sans-serif")
    .attr("font-weight", "bold")
    .text(`Porcentaje de ${titulo.value}`);

  texto_y.value
    .attr("transform", "rotate(-90)")
    .attr("y", 15)
    .attr("x", -(alto.value + margenes.value.arriba + margenes.value.abajo) / 2)
    .attr("font-size", "16")
    .attr("font-weight", "bold")
    .attr("font-family", "Avenir, Helvetica, Arial, sans-serif")
    .text("Causa");
}

function dibujanding() {
  console.log("se dibujaron los rectangulos");
  grupo_barras.value
    .selectAll("rect")
    .data(data.value)
    .join("rect")
    .attr("x", escala_X.value(0))
    .attr("y", (d) => escala_Y.value(d.key))
    .attr("height", escala_Y.value.bandwidth())
    .attr(
      "width",
      (d) => escala_X.value(d.porcentaje_redondeado) - escala_X.value(0)
    )
    .attr("fill", bars_color.value)
    .attr("opacity", 0.5);

  // Armas de fuego
  /*   grupo_afuego.value
    .selectAll("rect")
    .data(data.value[0]["xlugar"])
    .join("rect")
    .attr("x", (d) => escala_X.value(Math.floor(d.index / 10)) + borde.value)
    .attr(
      "y",
      (d) => escala_Y.value("Arma de fuego") + escala_subY.value(d.index % 10)
    )
    .attr("height", escala_subY.value.bandwidth())
    .attr("width", ancho_rect.value)
    .attr("fill", (d) => color_dict.value[d.lugar])
    .on("mouseover", abrirTooltip)
    .on("mouseleave", cerrarTooltip)
    .on("mousemove", ajustarPosicionTooltip); */

  grupo_afuego.value.selectAll("image").remove();
  grupo_afuego.value
    .selectAll("image")
    .data(data.value[0]["xlugar"])
    .join("image")
    .attr("href", (d) => {
      console.log(d);
      if (d.lugar == "calle") {
        return require(`../assets/img/persona_roja.png`);
      } else if (d.lugar == "vivienda") {
        return require(`../assets/img/persona_naranja.png`);
      } else if (d.lugar == "otro") {
        return require(`../assets/img/persona_azul.png`);
      } else if (d.lugar == "se_ignora") {
        return require(`../assets/img/persona_morada.png`);
      }
    })
    .attr("x", (d) => escala_X.value(Math.floor(d.index / 10)) + borde.value)
    .attr(
      "y",
      (d) => escala_Y.value("Arma de fuego") + escala_subY.value(d.index % 10)
    )
    .attr("height", escala_subY.value.bandwidth())
    .attr("width", ancho_rect.value)
    .on("mouseover", abrirTooltip)
    .on("mouseleave", cerrarTooltip)
    .on("mousemove", ajustarPosicionTooltip);

  // Armas blanca
  /*   grupo_ablanca.value
    .selectAll("rect")
    .data(data.value[1]["xlugar"])
    .join("rect")
    .attr("x", (d) => escala_X.value(Math.floor(d.index / 10)) + borde.value)
    .attr(
      "y",
      (d) => escala_Y.value("Arma blanca") + escala_subY.value(d.index % 10)
    )
    .attr("height", escala_subY.value.bandwidth())
    .attr("width", ancho_rect.value)
    .attr("fill", (d) => color_dict.value[d.lugar])
    .on("mouseover", abrirTooltip)
    .on("mouseleave", cerrarTooltip)
    .on("mousemove", ajustarPosicionTooltip); */

  grupo_ablanca.value.selectAll("image").remove();
  grupo_ablanca.value
    .selectAll("image")
    .data(data.value[1]["xlugar"])
    .join("image")
    .attr("href", (d) => {
      console.log(d);
      if (d.lugar == "calle") {
        return require(`../assets/img/persona_roja.png`);
      } else if (d.lugar == "vivienda") {
        return require(`../assets/img/persona_naranja.png`);
      } else if (d.lugar == "otro") {
        return require(`../assets/img/persona_azul.png`);
      } else if (d.lugar == "se_ignora") {
        return require(`../assets/img/persona_morada.png`);
      }
    })
    .attr("x", (d) => escala_X.value(Math.floor(d.index / 10)) + borde.value)
    .attr(
      "y",
      (d) => escala_Y.value("Arma blanca") + escala_subY.value(d.index % 10)
    )
    .attr("height", escala_subY.value.bandwidth())
    .attr("width", ancho_rect.value)
    .on("mouseover", abrirTooltip)
    .on("mouseleave", cerrarTooltip)
    .on("mousemove", ajustarPosicionTooltip);

  // Armas blanca
  /*   grupo_asfixia.value
    .selectAll("rect")
    .data(data.value[2]["xlugar"])
    .join("rect")
    .attr("x", (d) => escala_X.value(Math.floor(d.index / 10)) + borde.value)
    .attr(
      "y",
      (d) => escala_Y.value("Asfixia") + escala_subY.value(d.index % 10)
    )
    .attr("height", escala_subY.value.bandwidth())
    .attr("width", ancho_rect.value)
    .attr("fill", (d) => color_dict.value[d.lugar])
    .on("mouseover", abrirTooltip)
    .on("mouseleave", cerrarTooltip)
    .on("mousemove", ajustarPosicionTooltip); */

  grupo_asfixia.value.selectAll("image").remove();
  grupo_asfixia.value
    .selectAll("image")
    .data(data.value[2]["xlugar"])
    .join("image")
    .attr("href", (d) => {
      console.log(d);
      if (d.lugar == "calle") {
        return require(`../assets/img/persona_roja.png`);
      } else if (d.lugar == "vivienda") {
        return require(`../assets/img/persona_naranja.png`);
      } else if (d.lugar == "otro") {
        return require(`../assets/img/persona_azul.png`);
      } else if (d.lugar == "se_ignora") {
        return require(`../assets/img/persona_morada.png`);
      }
    })
    .attr("x", (d) => escala_X.value(Math.floor(d.index / 10)) + borde.value)
    .attr(
      "y",
      (d) => escala_Y.value("Asfixia") + escala_subY.value(d.index % 10)
    )
    .attr("height", escala_subY.value.bandwidth())
    .attr("width", ancho_rect.value)
    .on("mouseover", abrirTooltip)
    .on("mouseleave", cerrarTooltip)
    .on("mousemove", ajustarPosicionTooltip);

  // Otras
  /*   grupo_otras.value
    .selectAll("rect")
    .data(data.value[3]["xlugar"])
    .join("rect")
    .attr("x", (d) => escala_X.value(Math.floor(d.index / 10)) + borde.value)
    .attr("y", (d) => escala_Y.value("Otras") + escala_subY.value(d.index % 10))
    .attr("height", escala_subY.value.bandwidth())
    .attr("width", ancho_rect.value)
    .attr("fill", (d) => color_dict.value[d.lugar])
    .on("mouseover", abrirTooltip)
    .on("mouseleave", cerrarTooltip)
    .on("mousemove", ajustarPosicionTooltip); */

  grupo_otras.value.selectAll("image").remove();
  grupo_otras.value
    .selectAll("image")
    .data(data.value[3]["xlugar"])
    .join("image")
    .attr("href", (d) => {
      console.log(d);
      if (d.lugar == "calle") {
        return require(`../assets/img/persona_roja.png`);
      } else if (d.lugar == "vivienda") {
        return require(`../assets/img/persona_naranja.png`);
      } else if (d.lugar == "otro") {
        return require(`../assets/img/persona_azul.png`);
      } else if (d.lugar == "se_ignora") {
        return require(`../assets/img/persona_morada.png`);
      }
    })
    .attr("x", (d) => escala_X.value(Math.floor(d.index / 10)) + borde.value)
    .attr("y", (d) => escala_Y.value("Otras") + escala_subY.value(d.index % 10))
    .attr("height", escala_subY.value.bandwidth())
    .attr("width", ancho_rect.value)
    .on("mouseover", abrirTooltip)
    .on("mouseleave", cerrarTooltip)
    .on("mousemove", ajustarPosicionTooltip);

  // Sin especificar
  /*   grupo_se.value
    .selectAll("rect")
    .data(data.value[4]["xlugar"])
    .join("rect")
    .attr("x", (d) => escala_X.value(Math.floor(d.index / 10)) + borde.value)
    .attr(
      "y",
      (d) => escala_Y.value("Sin especificar") + escala_subY.value(d.index % 10)
    )
    .attr("height", escala_subY.value.bandwidth())
    .attr("width", ancho_rect.value)
    .attr("fill", (d) => color_dict.value[d.lugar])
    .on("mouseover", abrirTooltip)
    .on("mouseleave", cerrarTooltip)
    .on("mousemove", ajustarPosicionTooltip); */

  grupo_se.value.selectAll("image").remove();
  grupo_se.value
    .selectAll("image")
    .data(data.value[4]["xlugar"])
    .join("image")
    .attr("href", (d) => {
      console.log(d);
      if (d.lugar == "calle") {
        return require(`../assets/img/persona_roja.png`);
      } else if (d.lugar == "vivienda") {
        return require(`../assets/img/persona_naranja.png`);
      } else if (d.lugar == "otro") {
        return require(`../assets/img/persona_azul.png`);
      } else if (d.lugar == "se_ignora") {
        return require(`../assets/img/persona_morada.png`);
      }
    })
    .attr("x", (d) => escala_X.value(Math.floor(d.index / 10)) + borde.value)
    .attr(
      "y",
      (d) => escala_Y.value("Sin especificar") + escala_subY.value(d.index % 10)
    )
    .attr("height", escala_subY.value.bandwidth())
    .attr("width", ancho_rect.value)
    .on("mouseover", abrirTooltip)
    .on("mouseleave", cerrarTooltip)
    .on("mousemove", ajustarPosicionTooltip);
}

function abrirTooltip() {
  let seleccion = d3.select(this).datum();
  tooltip_causa.value = seleccion.causa;
  tooltip_prcntg_causa.value = seleccion.porcentaje_causa.toFixed(1);
  if (seleccion.lugar == "se_ignora") {
    tooltip_lugar.value = "no se especifica";
  } else if (seleccion.lugar == "otro") {
    tooltip_lugar.value = "otros";
  } else if (seleccion.lugar == "vivienda") {
    tooltip_lugar.value = "vivienda colectiva o particular";
  } else if (seleccion.lugar == "calle") {
    tooltip_lugar.value = "calle o carretera";
  }
  tooltip_prcntg_lugar.value = seleccion.porcentaje_lugar.toFixed(1);
  //console.log(seleccion);

  el_tooltip.value.style("visibility", "visible");
}

function cerrarTooltip() {
  el_tooltip.value.style("visibility", "hidden");
}
function ajustarPosicionTooltip() {
  let position = d3.pointer(event, document.body);
  let x = position[0] - 185;
  let y = position[1] + 20;

  if (x < 0) {
    x = position[0] + 20;
  }
  el_tooltip.value.style("left", x + "px").style("top", y + "px");
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.tooltip {
  position: absolute;
  z-index: 2;
  background-color: #252323;
  color: white;
  opacity: 0.93;
  height: auto;
  width: 175px;
  font-size: 14px;
  padding: 5px 5px;
  text-align: left;
}

@media (max-width: 850px) {
}
</style>
